export default __webpack_public_path__ + "../img/eed80fc7b4f3d635f9948b28a854be96.png";